export enum FeatureWidget {
  indoor = 'indoor',
  outdoor = 'outdoor',
  user_search = 'user_search',
}

export enum EWidgetType {
  user_setting = 'user',
  unit_setting = 'unit',
}
